// Import Packages
import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

// Import Material UI
import { IconButton } from "@material-ui/core";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';

// Import Pages
import ActiveDirectoryTable from './../ActiveDirectoryTable/ActiveDirectoryTable';
import { TextInput } from "../../../FlowConfigurationInputs/TextInput/NewTextInput";
import FieldLabel from '../../../FlowConfigurationInputs/FieldLabel/FieldLabel';

/**
 * @Description this page Active Directory  Library's Update Object  Action's configuration form
 * @Param       action - object
 * @Param       variables - object variable list
 * @Param       setOpenVariable - open variable function that allows us to open
 * @Returns     div element
 * @Author      Abdullah Onur Yeşil
 */
function UpdateObject({ action, variables, setOpenVariable }) {
    const { t } = useTranslation();
    const label = "CONTENT.CONFIGURATION-FORM.ACTIVE-DIRECTORY.";
    const [data, setData] = useState([]);
    const [index, setIndex] = useState(-1);
    const [open, setOpen] = useState(false);

    // set initial data 
    useEffect(() => {
        if (!action.fields.attributes) {
            action.fields.attributes = { value: [] };
        } else {
            setData(action.fields.attributes.value);
        }
    }, [action, variables]);

    useEffect(() => {
        if (data.length > 0) {
            action.fields.attributes.value = data;
        }

    }, [data, action.fields.attributes]);


    //open modal
    function handleOpenEdit(indx, setState) {
        setIndex(indx);
        setState(true);
    }

    return (
        <div>
            <div className="conf-field-container">
                <FieldLabel name={t(label + "MOVE-OBJECT.LDAP-PATH")} is_required={true} />
                <TextInput
                    action={action}
                    inputName="dn"
                    variables={variables}
                    setOpenVariable={setOpenVariable}
                    isRequired={true}
                    fieldType="string"
                    displayName={t(label + "MOVE-OBJECT.LDAP-PATH")}
                    hideRequired={true}
                />
                <small className='conf-field-desc'>cn=test,cn=Users,dc=autommate,dc=com</small>
            </div>
            
            <div className="conf-field-container">
                <FieldLabel name="Attributes" />
                <div className="items-center">
                    <table style={{ width: "90%" }}>
                        <thead>
                            <tr>
                                <th>Attribute Name</th>
                                <th>Attribute Value</th>
                                <th> </th>
                            </tr>
                        </thead>
                        <tbody>
                            {Array.isArray(data) &&
                                data.map((item, indx) => (
                                    <tr key={indx}>
                                        <td><span className="content-overflow" style={{ width: 85 }}>{item.key}</span></td>
                                        <td><span className="content-overflow" style={{ width: 85 }}>{item.value}</span></td>
                                        <td onClick={() => handleOpenEdit(indx, setOpen)}>
                                            <EditOutlinedIcon />
                                        </td>
                                    </tr>
                                ))}
                        </tbody>
                    </table>
                    <IconButton
                        style={{ padding: 0, float: "right" }}
                        onClick={() => setOpen(true)}
                    >
                        <AddCircleOutlineIcon style={{ paddingTop: 5, color: "#8C90A2" }} />
                    </IconButton>
                </div>
            </div>
            {open && (
                <ActiveDirectoryTable
                    index={index}
                    setOpen={setOpen}
                    setOpenVariable={setOpenVariable}
                    inputName="attributes"
                    action={action}
                    variables={variables}
                    setDictionaryTable={setData}
                    dictionaryTable={data}
                    setIndex={setIndex}
                    titles={["Attribute Name", "Attribute Value"]}
                />
            )}
        </div>
    );
}

export default UpdateObject;
